import { modifiers } from "ui-tools"
import { icons, type IconType } from "./icons"

import s from "./Icon.module.scss"

/**
 * A basic Icon component.
 *
 * Icons ready to use with the context of this component reside in `assets/icons` directory.
 *
 * Icons remaining in the `assets/icons` directory will be gradually adapted to use in this component.
 */
export const Icon = ({
  icon,
  rotate = 0,
  size = "medium",
  title,
  className = "",
}: {
  /**
   * Name of the icon to display.
   */
  icon: IconType
  /**
   * Clockwise rotation of the icon (in degrees).
   */
  rotate?: 0 | 90 | 180 | 270
  /**
   * Size of the icon.
   * `"small" | "medium" | "large" | "extraLarge"`
   */
  size?: "small" | "medium" | "large" | "extraLarge"
  /**
   * Optional title for the icon, used for accessibility.
   */
  title?: string
  /**
   * Additional CSS class to apply to the icon.
   * Should NOT be used to overwrite existing styles, but ex. for transform animation.
   */
  className?: string
}) => {
  const IconSVG = icons[icon]

  return (
    <IconSVG
      {...(title ? { title } : {})}
      className={`${modifiers(
        s,
        "icon",
        size,
        `rotate-${rotate}`
      )} ${className}`}
    />
  )
}
